import ChecklistNavigationListItemComponent, {
  ChecklistNavigationListItemComponentProps,
} from './ChecklistNavigationListItemComponent';

export default ChecklistNavigationListItemComponent;

export type { ChecklistNavigationListItemComponentProps };
